import { SnowplowService } from 'wanderu-service-analytics';

function liveCheckItineraryCompleted({ label, itineraryId }) {
    SnowplowService.fireStructuredEvent({
        category: 'react_livecheck',
        action: 'itinerary_completed',
        label,
        property: {
            itinerary_id: itineraryId,
        },
    });
}

export default {
    liveCheckItineraryCompleted,
};
